import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile
} from "@/helper/requests"

const state = {
  postgraduate: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getPostgraduate: state => state.postgraduate.items,
  getPostgraduateCount: state => state.postgraduate.count,
  getPostgraduateCurrentUrl: state => state.postgraduate.currentUrl,
  getPostgraduateNext: state => state.postgraduate.next,
  getPostgraduatePrev: state => state.postgraduate.prev,
  getPostgraduateDetail: state => state.postgraduate.detail,
  isLoadingPostgraduate: state => state.postgraduate.loading,
  savePostgraduateError: state => state.postgraduate.error,
}

const actions = {
  loadPostgraduate: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MEMBER.POSTGRADUATE.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingPostgraduate) {
      commit('SET_POSTGRADUATE_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_POSTGRADUATE', data.results)
          commit('SET_POSTGRADUATE_COUNT', data.count)
          commit('SET_POSTGRADUATE_CURRENT_URL', url)
          commit('SET_POSTGRADUATE_NEXT_URL', data.next)
          commit('SET_POSTGRADUATE_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_POSTGRADUATE_LOADING_END')
          commit('SAVE_POSTGRADUATE_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createPostgraduate: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.POSTGRADUATE.CREATE()
    commit('SET_POSTGRADUATE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  simplifiedCreatePostgraduate: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SIMPLIFIED.POSTGRADUATE()
    commit('SET_POSTGRADUATE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updatePostgraduate: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.POSTGRADUATE.UPDATE()
    commit('SET_POSTGRADUATE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_POSTGRADUATE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadPostgraduateDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.POSTGRADUATE.POSTGRADUATE.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_POSTGRADUATE_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_POSTGRADUATE_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_POSTGRADUATE: (state, value) => {
    state.postgraduate.items = value
  },
  SET_POSTGRADUATE_DETAIL: (state, value) => {
    state.postgraduate.detail = value
  },
  SET_POSTGRADUATE_COUNT: (state, value) => {
    state.postgraduate.count = value
  },
  SET_POSTGRADUATE_CURRENT_URL: (state, value) => {
    state.postgraduate.currentUrl = value
  },
  SET_POSTGRADUATE_NEXT_URL: (state, value) => {
    state.postgraduate.next = value
  },
  SET_POSTGRADUATE_PREV_URL: (state, value) => {
    state.postgraduate.prev = value
  },
  SET_POSTGRADUATE_LOADING: (state) => {
    state.postgraduate.loading = true
  },
  SET_POSTGRADUATE_LOADING_END: (state) => {
    state.postgraduate.loading = false
  },
  SAVE_POSTGRADUATE_ERROR: (state, error) => {
    state.postgraduate.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
